import { AVATAR_PLACEHOLDER_URL } from '@/store/constants/ui'

const extractUserAvatarUrl = (payload) => {
    let user = payload.user || null
    let avatarKey = payload.avatarKey || 'thumb_small'
    if (user && user.avatar_urls && user.avatar_urls[avatarKey]) {
        return user.avatar_urls[avatarKey]
    } else if (user && user.avatar && user.avatar[0] && user.avatar[0].uri) {
	    return user.avatar[0].uri
	} else {
	    return AVATAR_PLACEHOLDER_URL
    }
}
export default extractUserAvatarUrl

